import { render, staticRenderFns } from "./StaffDetailDialog.vue?vue&type=template&id=0b245f7f&scoped=true"
import script from "./StaffDetailDialog.vue?vue&type=script&lang=js"
export * from "./StaffDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./StaffDetailDialog.vue?vue&type=style&index=0&id=0b245f7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b245f7f",
  null
  
)

export default component.exports